<div class="wuc-compare-table-cell-extra-info" #extraInfoContent>
  <ng-content></ng-content>
</div>
<div *ngIf="extraInfoContent.innerText" class="wuc-compare-table-cell-extra-info__arrow">
  <wuc-icon type="primary" icon="arrowLO" size="l"></wuc-icon>
</div>
